// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "@github/relative-time-element"
import "./controllers"
import './controllers/third_party_controllers'
import * as bootstrap from "bootstrap"
import "chartkick/chart.js"
import "@fortawesome/fontawesome-free/js/all"

document.addEventListener("turbo:load", function () {
  // alert("Page loaded");
});

Turbo.StreamActions.redirect = function () {
  window.location.href = this.target
};

document.addEventListener("DOMContentLoaded", () => {
  const popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  popoverTriggerList.map((el) => new bootstrap.Popover(el))
})

document.addEventListener("shown.bs.modal", (event) => {
  const modal = event.target
  const popoverTriggerList = [].slice.call(
    modal.querySelectorAll('[data-bs-toggle="popover"]')
  )
  popoverTriggerList.map((el) => new bootstrap.Popover(el))
})
